import PrimeDatalayerTracking from "./PrimeDatalayerTracking";

export { default as PrimeDatalayerTrackingTripDetails } from "./PrimeDatalayerTrackingTripDetails";
export { default as PrimeUserTracking } from "./PrimeUserTracking";

export default PrimeDatalayerTracking;
